import { KdsInfoIcon, KdsText } from "@kazaar-platform/design-system";
import { RiCheckboxCircleFill, RiCloseCircleFill } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";

import { type OrderItemPageActivityLogPreMediaPropositionProps } from "./OrderItemPageActivityLogPreMediaProposition.types";

export const OrderItemPageActivityLogPreMediaProposition = ({
  validated,
}: OrderItemPageActivityLogPreMediaPropositionProps) => {
  const { t } = useTranslate();

  return (
    <div className="flex items-center gap-sp-xs2">
      <KdsText>
        {t(
          "order.myOrdersItemDetails.activityFeed.action.preMediaProposition.intro"
        )}
      </KdsText>

      <KdsInfoIcon
        icon={validated ? RiCheckboxCircleFill : RiCloseCircleFill}
        state={validated ? "success" : "error"}
        label={
          validated
            ? t(
                "order.myOrdersItemDetails.activityFeed.action.infoIcon.accepted"
              )
            : t(
                "order.myOrdersItemDetails.activityFeed.action.infoIcon.refused"
              )
        }
      />
    </div>
  );
};
